//core
import React from "react";

//components
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from "recharts";

//styles
import styles from "./LifeCompareBarGraph.module.scss";
import cx from "classnames";

interface ICoverAmounts {
    index: number;
    label: string;
    value: number[];
}

interface ITransformedData extends Omit<ICoverAmounts, "value"> {
    value: number[][];
}

interface ILifeCompareData {
    coverAmounts: ICoverAmounts[][];
    className: string;
}

const LifeCompareBarGraph: React.FC<ILifeCompareData> = (props) => {
    const { coverAmounts, className } = props;

    const getTransformedData = (): ITransformedData[] => {
        return coverAmounts[0]
            .map((item, index) => {
                return {
                    index: item.index,
                    label: item.label,
                    value: coverAmounts.map((s) => s[index].value)
                };
            })
            .reverse();
    };

    const data = getTransformedData();

    const colorList = ["#16ae8f", "#ff8f95"];

    return (
        <div className={cx(styles["chart-wrapper"], { [className]: !!className })}>
            <ResponsiveContainer height={320}>
                <BarChart
                    barGap={1}
                    data={data}
                    layout="vertical"
                    margin={{
                        right: 0,
                        left: 0
                    }}
                    className="text-font-size-xs text-semi-bold">
                    <CartesianGrid
                        strokeDasharray="2 2"
                        vertical={true}
                        horizontal={false}
                    />
                    <XAxis
                        type="number"
                        tickCount={7}
                        tickLine={false}
                        tickFormatter={() => ""}
                    />
                    <YAxis type="category" dataKey="label" tickLine={false} />
                    <Tooltip
                        formatter={(value, name, props, index) => {
                            return [`${value}%`, `Adult ${index + 1}`];
                        }}
                    />

                    {data[0]?.value.map((val, index) => {
                        return (
                            <Bar
                                key={index}
                                dataKey={`value.[${index}]`}
                                fill={colorList[index]}
                                barSize={9}
                            />
                        );
                    })}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default LifeCompareBarGraph;
